"use client";
import React, { useState, useEffect } from "react";
import RankingMap from "../../../components/Ranking/rankingmap";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";

/**
 * Client component wrapper for RankingMap
 * Manages geocoding and map state for SSR component
 * Now receives visible items from IntersectionObserver
 */
export default function RankingMapWrapper({
  cityName,
  stateName,
  selectedFilter,
  mapTitle,
  filterval,
  initialData = [],
  visibleItems = null, // New prop: receives visible items from list observer
}) {
  const [state, setState] = useState({
    lat: null,
    lng: null,
    nhmarkerdata: [],
    loading: true,
  });

  // Update markers when visible items change
  useEffect(() => {
    if (visibleItems && visibleItems.length > 0) {
      setState((prev) => ({
        ...prev,
        nhmarkerdata: visibleItems,
      }));
    }
  }, [visibleItems]);

  // Predefined coordinates for specific cities
  const cityCoordinates = {
    "San Francisco": { lat: 37.75771992816863, lng: -122.43759999999999 },
    Peninsula: { lat: 37.586439, lng: -122.3578237 },
    "Silicon Valley": { lat: 37.2963154, lng: -121.9805778 },
    "East Bay": { lat: 37.7837329, lng: -122.1198028 },
    Marin: { lat: 37.9567704, lng: -122.5497414 },
  };

  // Set city coordinates
  useEffect(() => {
    const setCityCoordinates = async () => {
      if (cityCoordinates[cityName]) {
        setState((prev) => ({
          ...prev,
          lat: cityCoordinates[cityName].lat,
          lng: cityCoordinates[cityName].lng,
          nhmarkerdata: initialData.slice(0, 3),
          loading: false,
        }));
        return;
      }

      try {
        const results = await geocodeByAddress(`${cityName}, ${stateName}`);
        const { lat, lng } = await getLatLng(results[0]);
        setState((prev) => ({
          ...prev,
          lat,
          lng,
          nhmarkerdata: initialData.slice(0, 3),
          loading: false,
        }));
      } catch (err) {
        console.error("Error geocoding:", err);
        // Fallback to California center
        setState((prev) => ({
          ...prev,
          lat: 36.7783,
          lng: -119.4179,
          nhmarkerdata: initialData.slice(0, 3),
          loading: false,
        }));
      }
    };

    if (cityName && stateName) {
      setCityCoordinates();
    }
  }, [cityName, stateName, initialData]);

  const handleViewClick = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("ispagemain", "true");
      localStorage.setItem("selectdnhranking", filterval);
      window.open(`/?address=${cityName}, ${stateName}, USA`, "_blank");
    }
  };

  if (state.loading || !state.lng || !state.lat || !initialData.length) {
    return (
      <div className="map_intial_loader">
        <p>Loading map...</p>
      </div>
    );
  }

  return (
    <div className="sticky-container">
      <div className="nhrankingmap_img">
        <h2 className="NhrankingTitles">{mapTitle}</h2>
        <RankingMap
          lat={state.lat}
          lng={state.lng}
          cityname={cityName}
          selectedfilter={selectedFilter}
          nhmarkerdata={state.nhmarkerdata}
          itemData={initialData}
        />
        <p onClick={handleViewClick} className="fullmapview">
          View Full Map
        </p>
      </div>
    </div>
  );
}
